module.exports = __webpack_public_path__ + "images/social-pic.0cd2128eeb8542aed5490009f399f2f0.jpg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/social-pic.jpg
// module id = 447
// module chunks = 0